module.exports = __webpack_public_path__ + "img/1S-hOv_ML32AY7B9eE3FTvt3UpouwZApU.80a86c82.jpg";